(() => {
  const select = $("[name='variant_id']");

  const state = {
    model: null,
    capacity: null,
    washer_color: null,
    rack_model: null,
    rack_length: null,
    rack_color: null
  };

  $(document).on("click", ".layout3 .item", function () {
    const type = $(this).data("type");
    const value = $(this).data("value");

    state[type] = value;

    if (type === "model") {
      // ✅ manually set active UI
      $(this).siblings().removeClass("active");
      $(this).addClass("active");

      const display = $(this).data("display") || value;

      $(this)
        .closest(".option-wrapper")
        .find(".sel")
        .text(display);

      // reset dependent selections
      state.capacity = null;
      state.washer_color = null;

      // run filter first
      filterAll();

      // 🔥 auto select capacity (safe)
      const firstCapacity = $(".layout3 [data-type='capacity'] .item:not(.hide)").first();
      if (firstCapacity.length) {
        $(".layout3 [data-type='capacity'] .item").removeClass("active");
        firstCapacity.addClass("active");

        const display = firstCapacity.data("display") || firstCapacity.data("value");
        $(".option-wrapper[data-type='capacity'] .sel").text(display);

        state.capacity = firstCapacity.data("value");
      }

      // 🔥 auto select color (safe)
      const firstColor = $(".layout3 [data-type='washer_color'] .item:not(.hide)").first();
      if (firstColor.length) {
        $(".layout3 [data-type='washer_color'] .item").removeClass("active");
        firstColor.addClass("active");

        const display = firstColor.data("display") || firstColor.data("value");
        $(".option-wrapper[data-type='washer_color'] .sel").text(display);

        state.washer_color = firstColor.data("value");
      }

      resolveVariant();
      return;
    }

    $(this).siblings().removeClass("active");
    $(this).addClass("active");

    const display = $(this).data("display") || value;

    $(this)
      .closest(".option-wrapper")
      .find(".sel")
      .text(display);

    filterAll();
    resolveVariant();
  });

  function filterAll() {

  // ================= WASHER =================

  // Capacity depends on model
  $(".layout3 [data-type='capacity'] .item").each(function () {
    const value = $(this).data("value");

    let valid = false;

    select.find("option").each(function () {
      const opt = $(this);

      if (
        (!state.model || opt.data("model") == state.model) &&
        opt.data("capacity") == value
      ) {
        valid = true;
        return false;
      }
    });

    toggleItem($(this), valid, "capacity");
  });

  // Washer color depends on model + capacity
  $(".layout3 [data-type='washer_color'] .item").each(function () {
    const value = $(this).data("value");

    let valid = false;

    select.find("option").each(function () {
      const opt = $(this);

      if (
        (!state.model || opt.data("model") == state.model) &&
        (!state.capacity || opt.data("capacity") == state.capacity) &&
        opt.data("washer_color") == value
      ) {
        valid = true;
        return false;
      }
    });

    toggleItem($(this), valid, "washer_color");
  });

  // ================= RACK =================

  // Rack model depends on NOTHING (always visible)
  $(".layout3 [data-type='rack_model'] .item").removeClass("hide");

  // Rack length depends on rack model
  $(".layout3 [data-type='rack_length'] .item").each(function () {
    const value = $(this).data("value");

    let valid = false;

    select.find("option").each(function () {
      const opt = $(this);

      if (
        (!state.rack_model || opt.data("rack_model") == state.rack_model) &&
        opt.data("rack_length") == value
      ) {
        valid = true;
        return false;
      }
    });

    toggleItem($(this), valid, "rack_length");
  });

  // Rack color depends on rack model + length
  $(".layout3 [data-type='rack_color'] .item").each(function () {
    const value = $(this).data("value");

    let valid = false;

    select.find("option").each(function () {
      const opt = $(this);

      if (
        (!state.rack_model || opt.data("rack_model") == state.rack_model) &&
        (!state.rack_length || opt.data("rack_length") == state.rack_length) &&
        opt.data("rack_color") == value
      ) {
        valid = true;
        return false;
      }
    });

    toggleItem($(this), valid, "rack_color");
  });
}

  function resolveVariant() {
    const match = select.find("option").filter(function () {
      const opt = $(this);

      return (
        (!state.model || opt.data("model") == state.model) &&
        (!state.capacity || opt.data("capacity") == state.capacity) &&
        (!state.washer_color || opt.data("washer_color") == state.washer_color) &&
        (!state.rack_model || opt.data("rack_model") == state.rack_model) &&
        (!state.rack_length || opt.data("rack_length") == state.rack_length) &&
        (!state.rack_color || opt.data("rack_color") == state.rack_color)
      );
    }).first();

    if (match.length) {
      select.val(match.val()).trigger("change");
    }
  }

  function toggleItem(el, valid, type) {
    if (valid) {
      el.removeClass("hide disabled");
    } else {
      el.addClass("hide").removeClass("active");

      if (state[type] == el.data("value")) {
        state[type] = null;
        $(`.option-wrapper[data-type='${type}'] .sel`).text('');
      }
    }
  }
  function selectFirstByModel(type) {
    const wrapper = $(`.option-wrapper[data-type='${type}']`);

    const model = state.model;

    const match = wrapper.find(`.item[data-model*='${model}']:not(.hide)`).first();

    if (match.length) {
      setActive(type, match.data("value"));
    }
  }
    // ================= CHANGE HANDLER (ADD THIS) =================
  select.on("change", function () {
    const value = $(this).val();
    const option = $(this).find(`option[value='${value}']`);

    console.log("Selected variant ID:", value);

    // ===== URL =====
    const url = new URL(window.location.href);
    url.searchParams.set("variant", value);
    window.history.replaceState(null, "", url.toString());

    // ===== CURRENT SELECTION =====
    $("#currentSelection").attr("data-variant", value);
    $("#currentSelection").attr("data-price", option.attr("data-price"));
    $("#currentSelection").attr("data-compare", option.attr("data-compare"));
    $("#currentSelection").attr("data-bundled-variant-ids", option.attr("data-bundled"));
    $("#currentSelection").attr("data-compare", option.attr("data-compare"));
    $("#currentSelection").attr("data-voucher", option.attr("data-voucher"));
    $("#currentSelection").attr("data-restock", option.attr("data-restock"));
    $("#currentSelection").attr("data-stocknum", option.attr("data-stockindicatornum"));

    $(".popup-content .dynamicCode").text(option.attr("data-voucherText"));

    // ===== TITLE =====
    $(".subtitle[data-variant_title]").text(option.attr("data-option") || "");

    // ===== EXISTING FUNCTIONS =====
    updateLinks();
    updatePrice();
    updateInstallment();
    updateVoucher();

    toggleATCbuttons();
    updateImage();
    updateRestock(); //has error, maybe due to current variants having no need to updateRestock individually
    updateStockIndicator();
  });

  // ================= ATC =================
  function toggleATCbuttons() {
    const selOption = select.find("option:selected");

    if (selOption.attr("data-available") == "true") {
      $("#AddToCart-button").show();
      $("#initateCheckout").show();
      $("#sold-out-btn").addClass("hide");
    } else {
      $("#AddToCart-button").hide();
      $("#initateCheckout").hide();
      $("#sold-out-btn").removeClass("hide");
    }
  }

  // ================= IMAGE =================
  function updateImage() {
    const value = select.val();
    const option = select.find(`option[value='${value}']`);
    const handle = option.attr("data-handle");

    $(".product-single__thumbnails-items").removeClass("active");
    $(".product-single__thumbnails-items." + handle).addClass("active");

    $(".product-single__thumbnails-items.main a").removeClass("active-thumb");
    $(".product-single__thumbnails-items.main." + handle + " a").addClass("active-thumb");

    $(".product-single__thumbnails-items.main a.active-thumb").click();
  }

  function updateRestock() {
    const $currentSelection = $("#currentSelection");

    // get restock value from current selection
    const restock = $currentSelection.attr("data-restock");

    const $target = $(".custom-attributes.product-restocks p b");

    if (restock && restock !== "null" && restock !== "") {
      $target.text(restock).show();
    } else {
      $target.text("").hide();
    }
  }

})();

// ================= INIT DEFAULT (WITH CASCADE + TIMEOUT) =================
$(document).ready(function () {
  $(".layout3 .item.active").each(function () {
    $(this).trigger("click");
  });

  setTimeout(function () {
    console.log('transfer warranty');
    $('.append-warranty').append($('.addon_by_variants-container.washer-warranty'));
  }, 500);
});

